import styles from "./FooterLogin.module.css"
import Link from 'next/link';
import { useRouter } from 'next/router';

function FooterLogin() {
      const router = useRouter();
    return (
        <div className={`text-center m-auto ${styles.footerText}`}>
            {/* <p>Copyright 2021 Celcom Axiata Berhad 198801000113 (167469-A). All Rights Reserved.</p> */}
            <p>Need more information? Check out our <a className="text-primary" onClick={() => {router.push({ pathname: "/support", query: { tab: 1 } });}}>FAQ</a></p>
        </div>

    )
}

export default FooterLogin;